import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { ScrollyArticle } from '../components/ScrollyPage/ScrollyArticle';

const DataPage = lazy(() => import('../components/ScrollyPage/DataPage'));

export const Route = createFileRoute('/om/data')({
    component: Index,
});

function Index() {
    return (
        <ScrollyArticle>
            <Suspense fallback={null}>
                <DataPage />
            </Suspense>
        </ScrollyArticle>
    );
}
